import * as yup from "yup";
import { ContractChangeFormValues } from "src/pages/ContractChange";

export const contractChangeInputsFormSchema: yup.ObjectSchema<ContractChangeFormValues> =
  yup.object({
    cancelContractType: yup.string().required(),
  });
